import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';

import { YellowButton } from '../../Buttons';
import { ReactComponent as IntercourseIcon } from 'assets/icons/intercourse.svg';

interface Date {
  date?: string;
}

export const IntercourseReminder = ({ date }: Date) => {
  const history = useHistory();

  return (
    <Box>
      <FlexContainer>
        <SimpleFlex>
          <IntercourseIcon />
          <div>
            <Date>{moment(date).format('dddd, MMM Do')}</Date>
            <h2>Intercourse reminder</h2>
            <p>Today&apos;s the day! Make sure to have sex with your partner today.</p>
          </div>
        </SimpleFlex>
        <AlignedYellowButton onClick={() => history.push(`/myjourney`)}>
          My Journey
        </AlignedYellowButton>
      </FlexContainer>
    </Box>
  );
};

const Box = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.nightMedium};
  box-shadow: -4px 4px ${({ theme }) => theme.colors.nightMedium};
  padding: 0.8em 0.8em 1.12em 1.4em;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  margin-bottom: 3em;

  h2 {
    font-size: 1.125em;
    font-weight: bold;
  }

  p {
    font-size: 1.143em;
  }

  svg {
    margin-right: 1.15em;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
  }
`;

const SimpleFlex = styled.div`
  display: flex;
  align-items: center;
`;

const Date = styled.div`
  font-size: 0.88em;
`;

const AlignedYellowButton = styled(YellowButton)`
  height: min-content;
  align-self: center;
  margin-top: 1em;
  white-space: nowrap;
`;
